<template>
  <div class="scratch-wrapper">
    <div class="scratch-container">
      <!-- <div class="text-container"> </div> -->
      <tr-ui-title
        v-for="(title, index) in [scratch.scratchObj]"
        :key="scratch.id + '_' + index"
        class="free-position"
        :style="getCustomStyle(scratch.scratchObj)"
        :title-text="title.text"
        :audio="title.audio"
        :pos="title.pos"
        :width="730"
        :height="145"
      ></tr-ui-title>
      <div class="image-container">
        <div
          class="image-element"
          title="Aby rozpocząć, kliknij w przycisk."
          @click="scratchLuncher(scratch.scratchObj.item.url)"
        >
          <img draggable="false" :src="imagePath(scratch.icon)" class="icon-off" />
          <img draggable="false" :src="imagePath(scratch.icon, false)" class="icon-on" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import TrUiTitle from '__mainSrcDir/components/TrGame/v4/UI/TrUiTitle/TrUiTitle';
export default {
  name: 'tr-scratch',
  components: {
    TrUiTitle,
  },
  methods: {
    scratchLuncher(link) {
      if (link) {
        if (this.$store.getters.isWeb) {
          window.open(link, '_blank');
        } else {
          this.$electron.shell.openExternal(link);
        }
      }
      return false;
    },
    imagePath(iconId, off = true) {
      iconId = 'ikonaScratchStart';
      let images = require.context('../../../assets/icons/book/scratchIcons/', false, /\.png$/);
      return images('./' + iconId + '' + (off ? '-OFF' : '-ON') + '.png');
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {
    scratch() {
      return this.$store.getters.scratchData;
    },
    modalActive() {
      return this.$store.getters.modalActive;
    },
  },
};
</script>
<style lang="scss" scoped>
.scratch-container {
  width: 850px;
  height: 350px;
  z-index: 999;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .image-container {
    position: relative;
    pointer-events: auto;
    top: 180px;
    left: 345px;
    width: 179px;
    height: 143px;
    .image-element {
      width: 100%;
      height: 100%;
      z-index: 1005;
      background-repeat: no-repeat;
      background-size: contain;
      position: relative;
      visibility: visible;
      opacity: 1;
      cursor: pointer;
      // transition: visibility 0s, opacity 0.3s ease-in;
    }
    .image-element .icon-off {
      visibility: visible;
      opacity: 1;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1006;
      width: 100%;
      height: 100%;
      -webkit-font-smoothing: subpixel-antialiased;
      backface-visibility: hidden;
      transition: visibility 0s, opacity 0.3s ease-out;
    }
    .image-element .icon-on {
      visibility: hidden;
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1006;
      width: 100%;
      height: 100%;
      -webkit-font-smoothing: subpixel-antialiased;
      backface-visibility: hidden;
      transition: visibility 0s, opacity 0.3s ease-out;
    }
    .image-element:hover .icon-on {
      visibility: visible;
      opacity: 1;
      -webkit-font-smoothing: subpixel-antialiased;
      backface-visibility: hidden;
      // transition: visibility 0s, opacity 0.3s ease-in;
    }
    // }
  }
  .free-position {
    position: absolute;
    pointer-events: auto;
    z-index: 1006;
  }
}
</style>
